import { FC, useEffect, useState } from "react";
import { Draggable, Droppable, DragDropContext, DropResult } from "react-beautiful-dnd";
import { ReactComponent as DragIcon } from '../../../assets/icons/drag.svg';

import { useSelector } from "react-redux";

import styles from "../headerBtn.module.scss";

interface ISettingOptions {
  setReorderedReportOptions: (el: { value: string, label: string }[]) => void;
  isCheckedFullInfo: boolean;
  setSelectedReportTabs: (check: string[]) => void;
  setIsCheckedFullInfo: (el: boolean) => void;
  selectedReportTabs: string[];
};

const requiredValues = [
  "mainInfo",
  "easymerch",
  "geo",
  "photos",
  "files",
  "planogramms",
  "cv",
  "skus",
  "skusSummary",
  "actionsTT",
  "actions",
  "skuCv",
  "review",
  "rate",
  "history",
  "techCard",
];

const AdminSingleReportSettingsSection: FC<ISettingOptions> = ({
  setReorderedReportOptions,
  setSelectedReportTabs,
  setIsCheckedFullInfo,
  selectedReportTabs,
  isCheckedFullInfo,
}) => {
  const { initialAdminReportOptions, reorderedOptions } = useSelector(
    (state: any) => state.userSingleReport.userSingleReport
  );
  const { darkTheme } = useSelector((state: any) => state.theme.theme);

  const [filteredOptions, setFilteredOptions] = useState<{ value: string, label: string }[]>(
    reorderedOptions || initialAdminReportOptions
  );

  useEffect(() => {
    filteredOptions && setReorderedReportOptions(filteredOptions);
  }, [filteredOptions, setReorderedReportOptions]);

  const handleChangeCheckbox = (name: string) => {
    if (name === "mainInfo") return;
    const updatedSettings = selectedReportTabs.includes(name)
      ? selectedReportTabs.filter((elem: string) => elem !== name)
      : [...selectedReportTabs, name];

    setSelectedReportTabs(updatedSettings);
    const isEqual =  filteredOptions.every(obj => updatedSettings.includes(obj.value));
    setIsCheckedFullInfo(isEqual);
  };

  const handleChangeFullInfoCheckbox = () => {
    if (!isCheckedFullInfo) {
      setSelectedReportTabs(requiredValues);
    } else {
      setSelectedReportTabs(["mainInfo"]);
    }
    setIsCheckedFullInfo(!isCheckedFullInfo);
  };

  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) return;
    const optionsToUpdate: { value: string; label: string }[] = Array.from(filteredOptions);
    const [movedOption] = optionsToUpdate.splice(result.source.index, 1);
    optionsToUpdate.splice(result.destination.index, 0, movedOption);
    setReorderedReportOptions(optionsToUpdate);
    setFilteredOptions(optionsToUpdate);
  };

  const handleResetOrder = () => {
    setFilteredOptions(initialAdminReportOptions);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <div className={styles.settings__block_info}>
        <Droppable droppableId="options">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className={styles.check__list_block}
            >
              {filteredOptions?.map((option: { value: string, label: string }, index: number) => (
                <Draggable
                  draggableId={index.toString()}
                  index={index}
                  key={index}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className={styles.check__list_elem}
                    >
                      <label className={styles.checkbox__container}>
                        <input
                          checked={selectedReportTabs.includes(option.value)}
                          type="checkbox"
                          onChange={() => handleChangeCheckbox(option.value)}
                        />
                        <span className={styles.multi__reason_checkmark}></span>
                      </label>
                      {option.label}
                      <DragIcon color={darkTheme.isDarkTheme ? 'white' : 'black'} className={styles.icon} />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
              <div className={styles.check__list_elem}>
                <label className={styles.checkbox__container}>
                  <input
                    type={"checkbox"}
                    onChange={handleChangeFullInfoCheckbox}
                    checked={isCheckedFullInfo}
                  />
                  <span className={styles.multi__reason_checkmark}></span>
                </label>
                Полная информация
              </div>
              <button
                className={styles.reset__order_btn}
                onClick={handleResetOrder}
              >
                Сбросить расположение блоков
              </button>
            </div>
          )}
        </Droppable>
      </div>
    </DragDropContext>
  );
};

export default AdminSingleReportSettingsSection;
